import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// @ts-ignore Ignore unused commented AuthGuard import
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import {
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
  AgrPageDetailModule,
  AgrNotificationEmptyModule,
  AgrBlockSpinnerModule,
} from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { TableV2Module } from '@next/core-lib/table-v2';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';

import { ContactpersonAuthorizationsComponent } from './components/contactperson-authorizations/contactperson-authorizations.component';
import { ContactpersonDetailComponent } from './components/contactperson-detail/contactperson-detail.component';
import { ContactpersonItemComponent } from './components/contactperson-item/contactperson-item.component';
import { ContactpersonNavigationComponent } from './components/contactperson-navigation/contactperson-navigation.component';
import { ContactpersonOverviewComponent } from './components/contactperson-overview/contactperson-overview.component';
import { RelationsLocationDetailComponent } from './components/contactperson-relations/relations-location-detail/relations-location-detail.component';
import { RelationsOverviewComponent } from './components/contactperson-relations/relations-overview/relations-overview.component';
import { ContactpersonComponent } from './contactperson.component';
import { AuthorizationService } from './services/authorization.service';
import { ContactpersonService } from './services/contactperson.service';
import { ContactpersonEffects } from './store/contactperson.effects';
import * as contactpersonReducer from './store/contactperson.reducer';
import { AgrSearchFieldModule } from '../shared/components/search-field/search-field.module';

@NgModule({
  declarations: [
    ContactpersonComponent,
    ContactpersonOverviewComponent,
    ContactpersonItemComponent,
    ContactpersonDetailComponent,
    ContactpersonAuthorizationsComponent,
    RelationsOverviewComponent,
    ContactpersonNavigationComponent,
    RelationsLocationDetailComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    AgrSearchFieldModule,
    AgrPageToolbarModule,
    AgrPageDetailModule,
    AgrPrimaryActionModule,
    AgrNotificationEmptyModule,
    AgrBlockSpinnerModule,
    MatListModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    AgrFormModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatSlideToggleModule,
    TableV2Module,
  ],
  providers: [
    ContactpersonService,
    AuthorizationService,
    provideState('contactpersonModule', contactpersonReducer.reducer),
    provideEffects([ContactpersonEffects]),
  ],
})
export class ContactpersonModule {}
